export class Budget {
    constructor() {

    }
    public getMediaCategories(list: any) {
        let mediaCategories = [];
        for (let i = 0; i < list.length; i++) {
            if (list[i].isMedia === 1) {
                mediaCategories.push(String(list[i].productCategoryId));
            }
        }
        return mediaCategories;

    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/budget/services/budget.service.ts